export const FETCH_NOTIFICATIONS__BEGIN = 'FETCH_NOTIFICATIONS__BEGIN';
export const FETCH_NOTIFICATIONS__RESOLVE = 'FETCH_NOTIFICATIONS__RESOLVE';
export const SEEN_NOTIFICATION__BEGIN = 'SEEN_NOTIFICATION__BEGIN';
export const SEEN_NOTIFICATION__RESOLVE = 'SEEN_NOTIFICATION__RESOLVE';
export const SUBSCRIBE_NOTIFICATIONS = 'SUBSCRIBE_NOTIFICATIONS';
export const ABORT_NOTIFICATIONS = 'ABORT_NOTIFICATIONS';
